module.exports = __webpack_public_path__ + "static/Papaya-1ad181606fe88d8e2fc77202f56bd37f.png";